import React, { useState, useEffect, useMemo } from "react";
import "./ProgressBarChart.css";


const demoTraits = [
  { label: "loading...", value: 0, color: "#b8943c" },
  { label: "loading...", value: 0, color: "#5c8ecf" },
  { label: "loading...", value: 0, color: "#4db6ac" },
  { label: "loading...", value: 0, color: "#7e9fd8" },
  { label: "loading...", value: 0, color: "#ff8183" },
  // { label: "", value: 0, color: "#b8f976" },
];

function ProgressBarChart({ testData , title}) {
  
  const [traits, setTraits] = useState(demoTraits);

  const apiLoaded = !!testData;

  useEffect(() => {
    if (apiLoaded) return;

    const interval = setInterval(() => {
      setTraits(prev =>
        prev.map(item => ({
          ...item,
          value: Math.min(
            item.value + Math.floor(Math.random() * 6) + 2,
            95 
          )
        }))
      );
    }, 250);

    return () => clearInterval(interval);
  }, [apiLoaded]);

 
  const realTraits = useMemo(() => {
    if (!testData?.data?.length) return [];

    const colors = ["#b8943c", "#5c8ecf", "#4db6ac", "#7e9fd8", "#ff8183", "#b8f976"];

    return testData.data.map((item, index) => {
      const leftLabel = item.resultcategory?.left_label || "";
      const rightLabel = item.resultcategory?.right_label || "";

      const label = item.letter === "left" ? leftLabel : rightLabel;
      const value = Math.round(
        item.letter === "left"
          ? parseFloat(item.left_result)
          : parseFloat(item.right_result)
      );

      return {
        label,
        value,
        color: colors[index % colors.length],
      };
    });
  }, [testData]);

  useEffect(() => {
    if (!apiLoaded || !realTraits.length) return;

    setTimeout(() => {
      setTraits(realTraits);
    }, 400);
  }, [apiLoaded, realTraits]);

  return (
    <div className="cal-chart-div1">
      <div className="chart-title">
        <h6>{title}</h6>
        <div className="progress-live">
          <span></span> <span>Live</span>
        </div>
      </div>

      <div className="progress-div">
        {traits.map((item, index) => (
          <div className="progress-row" key={index}>
            <div className="progress-header">
              <span>{item.label}</span>
              <span>{item.value}%</span>
            </div>

            <div className="progress-bar-sep">
              <div
                className="progress-fill-color"
                style={{
                  width: `${item.value}%`,
                  backgroundColor: item.color,
                  transition: "width 0.8s ease",
                }}
              />
              <div
                className="progress-remaining"
                style={{
                  width: `${100 - item.value}%`,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProgressBarChart;
